import useBrandContext from 'Contexts/brand-context';
import useCustomerContext from 'Contexts/customer-context';
import Page from 'Shared/components/page/page';
import Description from 'Shared/components/description';
import InlineSvg from 'Shared/components/inline-svg';
import Button from 'Shared/components/button';
import { useTranslation } from 'Shared/util/custom-hooks';
import SubmitInvoices from './components/submit-invoices';
import styles from './manual-setup-page.css';


const ManualSetupPage = () => {
  const { brandData, loadingBrandData } = useBrandContext();
  const { customerData, loadingCustomerData } = useCustomerContext();
  const t = useTranslation(x => x.manual);

  const {
    name: brandName,
    invoiceEmailAddress,
  } = brandData;

  const { organizationNumber } = customerData;

  const handleManualInvoiceClick = () => {
    if (invoiceEmailAddress) {
      window.location.href = `mailto:${invoiceEmailAddress}?subject=${organizationNumber}`;
    }
  };

  const showEmailSection = (brandName !== 'EuroFinans');
  const showEmailInvoiceButton = (showEmailSection && brandName === 'FinanceLink');

  return (
    <Page
      title={{
        text: t.submit_your_invoices,
        reducedMarginBottom: true,
      }}
      narrowWidth
      loading={loadingBrandData || loadingCustomerData}
    >
      <SubmitInvoices />

      {showEmailSection && (
        <div className={styles.emailSection}>
          <div className={styles.actionContainer}>
            <InlineSvg
              src="/integration/email-envelope.svg"
              className={styles.svgContainer}
            />
            {showEmailInvoiceButton && (
              <Button
                buttonType="action-secondary"
                text={t.invoices_via_email}
                onClick={handleManualInvoiceClick}
                className={styles.emailButton}
              />
            )}
          </div>
          <div className={styles.descriptionContainer}>
            <div className={styles.descriptionHeader}>{t.submit_invoices_by_email}</div>
            <Description text={t.format(t.invoices_via_email_description_part_1, { invoiceEmailAddress })} />
            <Description text={t.invoices_via_email_description_part_2} />
            <Description text={t.invoices_via_email_description_part_3} />
          </div>
        </div>
      )}
    </Page>
  );
};

export default ManualSetupPage;
